export default __webpack_public_path__ + "static/horn_strobe_w.36ea16c7322a77e0c899b2db0874bb89.png";